import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import type { HotelProvider } from '@/interfaces';

const secretKey = '6f5b0ff2-4683-490f-ab26-def49e945e84';

export interface EncryptedOutPageData {
    deepLink?: string;
    provider?: HotelProvider;
}

export const encrypt = (decryptedObject: EncryptedOutPageData): string => {
    const decryptedString = JSON.stringify(decryptedObject);
    const encryptedString = AES.encrypt(decryptedString, secretKey).toString();
    return btoa(encryptedString);
};

export const decrypt = (encryptedString: string): EncryptedOutPageData | undefined => {
    try {
        const decodedString = atob(encryptedString);
        const decryptedString = AES.decrypt(decodedString, secretKey).toString(Utf8);
        const decryptedObject = JSON.parse(decryptedString);
        if (!decryptedObject.deepLink || !decryptedObject.provider?.code) {
            return undefined;
        }
        return decryptedObject;
    } catch (e) {
        return undefined;
    }
};
